import axios from 'axios'
import { setupAuthInterceptor } from '@/lib/authInterceptor'
import { SSO_API_BASE_URL } from '@/features/auth/api/endpoints'

export interface GoogleDriveStatusData {
  connected: boolean
  google_email?: string | null
  email_match?: boolean
  scope?: string
  updated_at?: number
}

interface GoogleDriveTokenData {
  access_token: string
  expires_in: number
  token_type: string
}

interface GoogleDriveEnvelope<T> {
  success: boolean
  data?: T
  code?: number
  messageCode?: string
  message?: string
}

const googleDriveAxios = axios.create({
  baseURL: SSO_API_BASE_URL,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
})

setupAuthInterceptor(googleDriveAxios)

async function unwrap<T>(request: Promise<{ data: GoogleDriveEnvelope<T> }>): Promise<GoogleDriveEnvelope<T>> {
  try {
    return (await request).data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      return error.response.data as GoogleDriveEnvelope<T>
    }
    throw error
  }
}

export const googleDriveApi = {
  status: () => unwrap<GoogleDriveStatusData>(googleDriveAxios.get('/v1/auth/google-drive/status')),
  exchangeCode: (code: string) => unwrap<GoogleDriveTokenData>(googleDriveAxios.post('/v1/auth/google-drive/exchange-code', { code })),
  refresh: () => unwrap<GoogleDriveTokenData>(googleDriveAxios.post('/v1/auth/google-drive/refresh-token', {})),
  revoke: () => unwrap<void>(googleDriveAxios.delete('/v1/auth/google-drive/revoke')),
}

export type { GoogleDriveEnvelope, GoogleDriveTokenData }
